import { gql } from "@apollo/client";

export const CREATE_INVITE = gql`
  mutation createInvite($input: CreateInviteInput!) {
    createInvite(input: $input) {
      token
    }
  }
`;
